export const ADMIN_COMMENTS = {
  TITLE: 'Admin Comments',
};
